import React from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import DashboardPage from "./components/pages/DashboardPage/DashboardPage";
import ContractsPage from "./components/pages/ContractsPage/ContractsPage";
import ContractsAddPage from "./components/pages/ContractsPage/ContractsAddPage/ContractsAddPage";
import ContractsDissociatePage from "./components/pages/ContractsPage/ContractsDissociatePage/ContractsDissociatePage";
import BollettaOnlinePage from "./components/pages/BollettaOnlinePage/BollettaOnlinePage";
import SociDocument from "./components/pages/Soci/SociDocuments/SociDocuments";
import BillsPage from "./components/pages/BillsPage/BillsPage";
import PayBillsPage from "./components/pages/PayBillsPage/PayBillsPage";
import AutoletturaPage from "./components/pages/AutoletturaPage/AuttoletturaPage";
import AddSelfReadPage from "./components/pages/SelfRead/AddSelfRead/SelfRead";
import ViewUsages from "./components/pages/ViewUsages/ViewUsages";
import ChangePasswordPage from "./components/pages/ChangePasswordPage/ChangePasswordPage";
import UserProfilePage from "./components/pages/UserProfilePage/UserProfilePage";
import RegistartionBackofficeOperatorPage from "./components/pages/RegistartionBackofficeOperator/RegistartionBackofficeOperator";
import ListCasePage from "./components/pages/ListCasePage/ListCasePage";
import Login from "./components/pages/Login/Login";
import Registration from "./components/pages/Registration/Registration";
import ForgotPasswordPage from "./components/pages/ForgotPasswordPage/ForgotPasswordPage";
import ValidateEmailPage from "./components/pages/ValidateEmailPage/ValidateEmailPage";
import RichiediInformazioniCase from "./components/pages/cases/RichiediInformazioniCase/RichiediInformazioniCase";
import RichiediSpurghiCase from "./components/pages/cases/RichiediSpurghiCase/RichiediSpurghiCase";
import FaiUnReclamoCase from "./components/pages/cases/FaiUnReclamoCase/FaiUnReclamoCase";
import SegnalaUnGuastoCase from "./components/pages/cases/SegnalaUnGuastoCase/SegnalaUnGuastoCase";
import AppuntamentoPuntoAcquaCase from "./components/pages/cases/AppuntamentoPuntoAcquaCase/AppuntamentoPuntoAcquaCase";
import AnalisiAcquaCase from "./components/pages/cases/AnalisiAcquaCase/AnalisiAcquaCase";
import VolturaCase from "./components/pages/cases/VolturaCase/VolturaCase";
import DenunciaPerditeCase from "./components/pages/cases/DenunciaPerditeCase/DenunciaPerditeCase";
import TutelaPerditeCase from "./components/pages/cases/TutelaPerditeCase/TutelaPerditeCase";
import RateizzazioneBollettaCase from "./components/pages/cases/RateizzazioneBollettaCase/RateizzazioneBollettaCase";
import AvvenutoPagamentoCase from "./components/pages/cases/AvvenutoPagamentoCase/AvvenutoPagamentoCase";
import PreventivoLavoriCase from "./components/pages/cases/PreventivoLavoriCase/PreventivoLavoriCase";
import DisattivazioneDellaFornituraCase from "./components/pages/cases/DisattivazioneDellaFornituraCase/DisattivazioneDellaFornituraCase";
import RettificaFatturazioneCase from "./components/pages/cases/RettificaFatturazioneCase/RettificaFatturazioneCase";
import VerificaMetricaCase from "./components/pages/cases/VerificaMetricaCase/VerificaMetricaCase";
import EstensioneReteEsistenteCase from "./components/pages/cases/EstensioneReteEsistenteCase/EstensioneReteEsistenteCase";
import VerificaContatoreCase from "./components/pages/cases/VerificaContatoreCase/VerificaContatoreCase";
import VerificaDellaPressioneCase from "./components/pages/cases/VerificaDellaPressioneCase/VerificaDellaPressioneCase";
import AllacciamentoCase from "./components/pages/cases/AllacciamentoCase/AllacciamentoCase";
import AllacciamentoFognaturaCase from "./components/pages/cases/AllacciamentoFognaturaCase/AllacciamentoFognaturaCase";
import LetturaSicuraPage from "./components/pages/LetturaSicuraPage/LetturaSicuraPage";
import RichiediOmaggioCase from "./components/pages/cases/RichiediOmaggioCase/RichiediOmaggioCase";
import ModificaDatiCase from "./components/pages/cases/ModificaDatiCase/ModificaDatiCase";
import HubPage from "./components/pages/HubPage/HubPage";
import MissingPage from "./components/pages/MissingPage/MissingPage";
import SubentroCase from "./components/pages/cases/SubentroCase/SubentroCase";
import OpereDiUrbanizzazi from "./components/pages/OpereDiUrbanizzazi/OpereDiUrbanizzazi";
import CaseDetailPage from "./components/pages/CaseDetailPage/CaseDetailPage";
import EmbedCasesPage from "./components/pages/EmbedCasesPage/EmbedCasesPage";
import TutelaPerdite from "./components/pages/TutelaPerditePage/TutelaPerdite";
import ModifyEmailPage from "./components/pages/ModifyEmailPage/ModifyEmailPage";
import ChatPage from "./components/pages/ChatPage/ChatPage";
import MaintenancePage from "./components/pages/MaintenancePage/MaintenancePage";
import ConfirmRegistration from "./components/pages/ConfirmRegistration/ConfirmRegistration";
import LogoutPage from "./components/pages/LogoutPage/LogoutPage";
import TracciamentoNuoveReti from "./components/pages/TracciamentoNuoveReti/TracciamentoNuoveReti";
import AreaSociPage from "./components/pages/AreaSociPage/AreaSociPage";
import RedirectExternal from "./components/common/RedirectExternal/RedirectExternal";
import SelfReadingListPage from "./components/pages/SelfReadingListPage/SelfReadingListPage";
import OauthAuthentication from "./components/OauthAuthentication/OauthAuthentication";
import SpidLogin from "./components/pages/SpidLogin/SpidLogin";
import SpidRegisterCase from "./components/pages/cases/SpidRegisterCase/SpidRegisterCase";
import OauthAuthenticationError
  from "./components/OauthAuthentication/OauthAuthenticationError/OauthAuthenticationError";
import TestCase from "./components/pages/cases/TestCase/TestCase";
import DomiciliazioneBancariaComplexCase
  from "./components/pages/cases/DomiciliazioneBancariaComplexCase/DomiciliazioneBancariaComplexCase";
import ToolAmministratoriCondominio from "./components/pages/ToolAmministratoriCondominio/ToolAmministratoriCondominio";
import AggiornaDatiCase from "./components/pages/AggiornaDatiPage/AggiornaDatiPage";
import ConfirmInternetExplorerPopup from "./components/common/ConfirmInternetExplorerPopup/ConfirmInternetExplorerPopup";
import ContractsSpidAddPage from "./components/pages/ContractsSpidAddPage/ContractsSpidAddPage.js";
import ModificaDomiciliazioneBancariaComplexCase from "./components/pages/cases/DomiciliazioneBancariaComplexCase/ModificaDomiciliazioneBancariaComplexCase"
import AssociaContrattoAmministratore from "./components/pages/AssociaContrattoAmministratore/AssociaContrattoAmministratore";

const AppRoutes = () => (
  <>

    <Switch>
      <PrivateRoute exact path="/contracts/add-spid" component={ContractsSpidAddPage} />  
      <PrivateRoute exact path="/operator/modify-email" component={ModifyEmailPage} />

      <PrivateRoute exact path="/dashboard" component={DashboardPage} />
      <PrivateRoute exact path="/contracts" component={ContractsPage} />
      <PrivateRoute exact path="/contracts/add" component={ContractsAddPage} />
      <PrivateRoute exact path="/contracts/add/condominium-admin" component={AssociaContrattoAmministratore} />
      <PrivateRoute
        exact
        path="/contracts/dissociate"
        component={ContractsDissociatePage}
      />
      <PrivateRoute exact path="/online-bills" component={BollettaOnlinePage} />

      <PrivateRoute exact path="/soci-documents" component={SociDocument} />

      <PrivateRoute exact path="/bills" component={BillsPage} />

      <PrivateRoute exact path="/bills/view-all" component={BillsPage} isFromDashboardLink={true} />

      <PrivateRoute path="/bills/payment-detail/:contractId/:trackIdPayment?" component={BillsPage} />

      <Route exact path="/verify-user/:username/:code?" component={ConfirmRegistration} />

      {/* <PrivateRoute exact path='/bills/:billId/pay' component={BillsPayPage}/> */}
      <PrivateRoute exact path="/payment" component={PayBillsPage} />
      <PrivateRoute exact path="/payment-success" component={BillsPage} />
      <PrivateRoute exact path="/payment-error" component={BillsPage} />

      <PrivateRoute exact path="/autolettura" component={AutoletturaPage} />

      <PrivateRoute exact path="/selfread-add" component={AddSelfReadPage} />

      <PrivateRoute exact path="/usages" component={ViewUsages} />

      {/*<PrivateRoute exact path="/cases" component={CasesPage} />*/}
      <Route exact path="/embed-cases/:type" component={EmbedCasesPage} />

      <PrivateRoute
        exact
        path="/change-password"
        component={ChangePasswordPage}
      />
      <PrivateRoute exact path="/user-profile" component={UserProfilePage} />


      <PrivateRoute exact path="/view-cases" component={ListCasePage} />
      <PrivateRoute exact path="/cases/:caseId" component={CaseDetailPage} />

      {/*<Route path="/master" component={MasterPage} />*/}

      <Route path="/maintenance" component={MaintenancePage} />

      <Route path="/auth/callback" component={OauthAuthentication} />
      <Route path="/auth/error" component={OauthAuthenticationError} />

      <Route path="/login" component={Login} />
      <Route path="/spid-login" component={SpidLogin} />
      <Route path="/register" component={Registration} />
      <PrivateRoute
        exact
        path="/register-operators"
        component={RegistartionBackofficeOperatorPage}
      />
      <Route path={"/redirect/:link"} component={RedirectExternal} />
      <Route path="/forgot-password/:token?" component={ForgotPasswordPage} />
      <Route path="/validate-email" component={ValidateEmailPage} />
      <PrivateRoute path="/logout" component={LogoutPage} />

      {/*public case*/}
      <Route
        path="/richiedi-spurghi"
        component={RichiediSpurghiCase}
      />
      <Route
        path="/richiedi-informazioni"
        component={RichiediInformazioniCase}
      />
      <Route
        path="/spid-register"
        component={SpidRegisterCase}
      />
      {/*<Route
        path="/richiedi-omaggio/:omaggio?"
        component={RichiediOmaggioCase}
      />*/}
      <Route path="/fai-un-reclamo" component={FaiUnReclamoCase} />
      <Route path="/segnala-un-guasto" component={SegnalaUnGuastoCase} />
      <Route
        path="/appuntamento-punto-acqua"
        component={AppuntamentoPuntoAcquaCase}
      />

      <Route
        path="/tool-amministratori-condominio"
        component={ToolAmministratoriCondominio}
      />
      <Route path="/aggiorna-dati" component={AggiornaDatiCase} />
       <PrivateRoute path="/test" component={TestCase} />

      {/*end-public case*/}

      <PrivateRoute path="/domiciliazione-bancaria" component={DomiciliazioneBancariaComplexCase} />
      <PrivateRoute path="/modifica-domiciliazione-bancaria" component={ModificaDomiciliazioneBancariaComplexCase} />


      {/*Complex Case*/}
      <Route path="/analisi-acqua/:tipo?/:payment?" component={AnalisiAcquaCase} />
      {/* <Route path="/analisi-acqua/:tipo?" component={AnalisiAcquaCase} /> */}

      <PrivateRoute path="/voltura" component={VolturaCase} />
      <PrivateRoute path="/subentro" component={SubentroCase} />
      <PrivateRoute path="/denuncia-perdite" component={DenunciaPerditeCase} />
      <PrivateRoute path="/tutela-perdite" component={TutelaPerditeCase} />

      <PrivateRoute path="/tutela" component={TutelaPerdite} />
      {/*end Complex Case*/}

      {/*Simple Case*/}
      <PrivateRoute
        path="/rateizzazione-bolletta"
        component={RateizzazioneBollettaCase}
      />
      <PrivateRoute
        path="/avvenuto-pagamento"
        component={AvvenutoPagamentoCase}
      />
      <PrivateRoute
        path="/preventivo-lavori"
        component={PreventivoLavoriCase}
      />

      <PrivateRoute
        path="/disattivazione-della-fornitura"
        component={DisattivazioneDellaFornituraCase}
      />
      <PrivateRoute
        path="/rateizzazione-bolletta"
        component={RateizzazioneBollettaCase}
      />
      <PrivateRoute
        path="/rettifica-fatturazione"
        component={RettificaFatturazioneCase}
      />
      <PrivateRoute path="/verifica-metrica" component={VerificaMetricaCase} />
      <PrivateRoute
        path="/estensione-rete-esistente"
        component={EstensioneReteEsistenteCase}
      />
      <PrivateRoute
        path="/verifica-contatore"
        component={VerificaContatoreCase}
      />
      <PrivateRoute
        path="/verifica-della-pressione"
        component={VerificaDellaPressioneCase}
      />

      <PrivateRoute exact path="/allacciamento" component={AllacciamentoCase} />

      <PrivateRoute
        path="/allacciamento/fognatura"
        component={AllacciamentoFognaturaCase}
      />

      <PrivateRoute path="/lettura-sicura" component={LetturaSicuraPage} />
      <PrivateRoute
        path="/opere-di-urbanizzazione"
        component={OpereDiUrbanizzazi}
      />
      <PrivateRoute
        path="/tracciamento-nuove-reti"
        component={TracciamentoNuoveReti}
      />
      <PrivateRoute
        path="/area-soci/:tab?"
        component={AreaSociPage}
      />
      <PrivateRoute
        path="/lista-autoletture"
        component={SelfReadingListPage}
      />

      <PrivateRoute path="/modifica-dati" component={ModificaDatiCase} />
      {/*end Simple Case*/}
      <Route path="/chat" component={ChatPage} />

      <Route path="/" component={HubPage} />
      <Route path="/404" component={MissingPage} />

      <Route path="*" component={MissingPage} />

    </Switch>
    <ConfirmInternetExplorerPopup />

  </>
);

AppRoutes.propTypes = {};

export default AppRoutes;
